
// sample custom styles
let styles = '';

// styles = `
// .ov-app-reperks-widget[data-app-id="12345"] {
//     font-family: "Georgia";
// }

// .ov-app-reperks-widget[data-app-id="12345"] .ov-reperks-widget .ov-reviews-content .ov-filters .ov-search-input {
//     display: none;
// }

// .ov-app-reperks-widget[data-app-id="12345"] .ov-reperks-widget .ov-reviews-content .ov-review .ov-profile .ov-country-flag {
//     display: none;
// }

// .ov-app-reperks-widget[data-app-id="12345"] .ov-reperks-widget .ov-summary .ov-write-btn {
//     display: none;
// }

// .ov-app-reperks-widget[data-app-id="12345"] .ov-write-review-modal-portal .ov-modal-box .ov-modal-footer .ov-footer-btn-group .ov-btn {
//     color: #fff;
//     background-color: #007c89;
// }

// .ov-app-reperks-widget[data-app-id="12345"] .ov-reperks-widget .ov-star-ratings .ov-star-default svg {
//     fill: #ccc;
// }

// .ov-app-reperks-widget[data-app-id="12345"] .ov-reperks-widget .ov-star-ratings .ov-star-highlight svg {
//     fill: #149671;
// }

// .ov-app-reperks-widget[data-app-id="12345"] .ov-reperks-widget .ov-summary .ov-summary-breakdown .ov-rating .ov-bar {
//     background-color: #ccc;
// }

// .ov-app-reperks-widget[data-app-id="12345"] .ov-reperks-widget .ov-summary .ov-summary-breakdown .ov-rating .ov-bar span.ov-highlight {
//     background-color: #149671;
// }
// `;


export default styles;
